import React from 'react';
export function TopoPattern({
  className = '',
  opacity = 0.05
}: {
  className?: string;
  opacity?: number;
}) {
  return <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`} style={{
    opacity
  }} data-id="element-369">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-370">
        <defs data-id="element-371">
          <pattern id="topo" width="200" height="200" patternUnits="userSpaceOnUse" data-id="element-372">
            <path d="M 0 100 Q 50 50 100 100 T 200 100" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-373" />
            <path d="M 0 120 Q 50 70 100 120 T 200 120" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-374" />
            <path d="M 0 140 Q 50 90 100 140 T 200 140" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-375" />
            <path d="M 0 160 Q 50 110 100 160 T 200 160" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-376" />
            <path d="M 0 180 Q 50 130 100 180 T 200 180" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-377" />
            <path d="M 0 200 Q 50 150 100 200 T 200 200" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-378" />
            <circle cx="150" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-379" />
            <circle cx="150" cy="50" r="30" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-380" />
            <circle cx="150" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-381" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#topo)" data-id="element-382" />
      </svg>
    </div>;
}